export default {
  coachSSO_iframeTitle: 'Zonar Coaching',
  coachSSO_error_unauthorized:
    'La integración Coaching SSO no está activa para su empresa. Contacte a su administrador.',
  coachSSO_error_notReady:
    'Coaching aún no está listo para su empresa. Intente más tarde o contacte a su administrador.',
  coachSSO_error_noTags:
    'No tiene etiquetas que existan en Coaching, así que no hay nada que mostrar. Pida a su administrador que le asigne etiquetas.',
  coachSSO_error_customError:
    'No pudimos crear el token de sesión de Coaching. Intente de nuevo. Si el problema persiste, contacte a soporte.',
  coachSSO_error_frameLoad:
    'No se pudo cargar el módulo de Coaching. Intente más tarde.',
  coachSSO_error_generic: 'Ocurrió un error al conectar con Coaching. Intente de nuevo.',
  coachSSO_tab_home: 'Inicio',
  coachSSO_tab_safetyEvents: 'Eventos de seguridad',
  coachSSO_tab_trips: 'Viajes',
  coachSSO_tab_liveView: 'Vista en vivo',
  coachSSO_tab_coaching: 'Coaching',
  coachSSO_tab_videoRequests: 'Solicitud de video',
  coachSSO_tab_challenges: 'Desafíos',
  coachSSO_tab_reports: 'Reportes',
  coachSSO_tab_configurations: 'Configuraciones',
};
